<template>
    <div class="flex items-center justify-center mx-auto my-6">
        <div
            v-for="(item, index) in productStatuses"
            :key="index"
        >
            <div class="flex">
                <div class="relative">
                    <div
                        class="w-6 h-6 rounded-full"
                        :class="index <= pos ? 'bg-green-500' : 'bg-gray-300'"
                    />
                    <p class="absolute text-xs -left-1/2">
                        {{ item }}
                    </p>
                </div>
                <div
                    v-if="index < productStatuses.length - 1"
                    :key="item"
                    class="h-1 w-16 -mx-2 mt-2.5"
                    :class="index <= pos ? 'bg-green-500' : 'bg-gray-300'"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        status: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            pos: 0,
            productStatuses: ['Placed', 'Packed', 'Shipped', 'Delivered'],
        };
    },

    watch: {
        status: {
            immediate: true,
            handler(value) {
                this.pos = this.changePosition(value);
            },
        },
    },

    methods: {
        changePosition(status) {
            const statuses = {
                Placed: 0,
                Packed: 1,
                Shipped: 2,
                Delivered: 3,
            };
            return statuses[status];
        },
    },
};
</script>
